export const normalizeAvatarUrl = (imgSrc) => {
  if (!imgSrc) return null;

  if (Array.isArray(imgSrc)) {
    const selectedPic = imgSrc.find((pic) => pic?.selected) || imgSrc[0];
    return normalizeAvatarUrl(selectedPic?.url || selectedPic?.src || null);
  }

  if (typeof imgSrc === "string") {
    const trimmed = imgSrc.trim();
    if (!trimmed) return null;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (trimmed.startsWith("/")) {
      return `${process.env.REACT_APP_NODEJS_SERVER_URL || ""}${trimmed}`;
    }
    if (trimmed.startsWith("uploads")) {
      return `${process.env.REACT_APP_NODEJS_SERVER_URL || ""}/${trimmed}`;
    }
    try {
      const parsed = JSON.parse(trimmed);
      return normalizeAvatarUrl(parsed);
    } catch {
      return trimmed;
    }
  }

  if (typeof imgSrc === "object") {
    if (imgSrc?.selectedImage) return normalizeAvatarUrl(imgSrc.selectedImage);
    return normalizeAvatarUrl(
      imgSrc?.url ||
      imgSrc?.src ||
      imgSrc?.href ||
      imgSrc?.path ||
      imgSrc?.imageUrl ||
      null
    );
  }

  return null;
};
